import {Component, OnInit, OnDestroy} from '@angular/core';
import {RouteService} from '../../shared/services/route.service';
import {Stop} from '../../shared/models/stop.model';
import {FormGroup, FormControl, FormArray, Validators} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {Subscription, Observable, Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var google: any;

@Component({
    selector: 'form-stop',
    templateUrl: 'form-stop.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormStopComponent implements OnInit, OnDestroy {

    constructor(private routeService: RouteService, private dataStorageService: DataStorageService) {
    }

    model;

    stopForm: FormGroup;
    stops: Stop[];

    private geoSub: Subscription;

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit(): void {

        this.stops = this.routeService.getStop();
        this.initForm();
        this.routeService.stopsChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe((stops: Stop[]) => {
                this.stops = stops;
                this.initForm();
            });

    }

    initForm() {

        const routeStops = new FormArray([]);
        if (this.stops) {
            for (const stop of this.stops) {
                routeStops.push(
                    new FormGroup({
                        'id': new FormControl(stop.id),
                        'title': new FormControl(stop.title),
                        'address': new FormControl(stop.address),
                        'map': new FormControl(stop.map),
                        'lat': new FormControl(stop.lat),
                        'lng': new FormControl(stop.lng)
                    })
                );
            }
        }
        this.stopForm = new FormGroup({
            'routeStops': routeStops
        });


    }

    getControls() {
        return (<FormArray>this.stopForm.get('routeStops')).controls;
    }

    onAddStop() {
        (<FormArray>this.stopForm.get('routeStops')).push(
            new FormGroup({
                'id': new FormControl(),
                'title': new FormControl(null, Validators.required),
                'address': new FormControl(),
                'map': new FormControl(),
                'lat': new FormControl(),
                'lng': new FormControl()
            })
        );
    }

    onGenerateMap(index: number) {
        const newStopValue = (<FormArray>this.stopForm.get('routeStops')).at(index);
        this.geoSub = this.getGeoLocation(newStopValue.value.address)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            data => {
                newStopValue.get('lat').patchValue(data.lat());
                newStopValue.get('lng').patchValue(data.lng());
            }
        );
    }

    onSubmitStop(index: number) {
        const newStopValue = (<FormArray>this.stopForm.get('routeStops')).at(index);
        const newStop = new Stop(newStopValue.value.title, newStopValue.value.address
            , newStopValue.value.map, newStopValue.value.lat, newStopValue.value.lng);
        if (newStopValue.value.id) {
            this.dataStorageService.updateStop(newStopValue.value.id, newStop);
        } else {
            this.dataStorageService.createStop(newStop);
        }
    }

    onDeleteStop(index: number) {
        const newStopValue = (<FormArray>this.stopForm.get('routeStops')).at(index);
        if (newStopValue.value.id) {
            if (confirm('Are you sure?')) {
                this.dataStorageService.deleteStop(newStopValue.value.id);
            }
        } else {
            (<FormArray>this.stopForm.get('routeStops')).removeAt(index);
        }
    }

    getGeoLocation(address: string): Observable<any> {
        console.log('Getting address: ', address);
        let geocoder = new google.maps.Geocoder();
        return Observable.create(observer => {
            geocoder.geocode({
                'address': address
            }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    observer.next(results[0].geometry.location);
                    observer.complete();
                } else {
                    console.log('Error: ', results, ' & Status: ', status);
                    observer.error();
                }
            });
        });
    }

    ngOnDestroy() {
        if (this.geoSub) {
            this.geoSub.unsubscribe();
        }
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
